import produce from 'immer'
import React, { useState } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { RouteComponentProps, useHistory } from 'react-router-dom'
import InvalidFeedback from '../../../components/common/invalidFeedback/InvalidFeedback'
import ConfirmationModal from '../../../components/modals/ConfirmationModal'
import { IDsDivision } from '../../../models/administrativeArea/IDsDivision'
import { ValidationObjectModel } from '../../../models/common/validationObjectModel'
import metaDataService from '../../../services/metaDataService'
import { dsFetchRequest } from '../../../store/administrativeArea/actions'
import {
  getDistritByDistrictId,
  getDsByDsId,
  getProvinceByProvinceId,
} from '../../../store/administrativeArea/selectors'
import {
  ALERT_WARNING,
  TOAST_POSITION_TOP_RIGHT,
  TOAST_TRANSITION_SLIDE,
  ALERT_SUCCESS,
} from '../../../utils/constants'
import { validationError } from '../../../utils/errorMessages'
import { showTotast } from '../../../utils/toast'
import { validateForm } from '../../../utils/utilFunctions'

interface ErrorModel {
  codeError?: string
  nameError?: string
}
type TParams = {
  provinceId: any
  districtId: string
  dsId: string
}
const ModifyDsDivistion = ({ match }: RouteComponentProps<TParams>) => {
  const [state, setSate] = useState({} as IDsDivision)
  const history = useHistory()
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [errors, setErrors] = useState({} as ErrorModel)
  const dispatch = useDispatch()
  const distrit = useSelector(
    getDistritByDistrictId(parseInt(match.params.districtId))
  )

  const province = useSelector(
    getProvinceByProvinceId(parseInt(match.params.provinceId))
  )

  const ds = useSelector(getDsByDsId(parseInt(match.params.dsId)))

  React.useEffect(() => {
    if (ds) {
      setSate({
        name: ds.name,
        code: ds.code,
        districtId: ds.districtId,
        id: ds.id,
        provinceId: ds.provinceId,
      })
    }
  }, [])

  const findFormErrors = () => {
    const newErrors = {} as ErrorModel
    if (
      validateForm({
        maxLength: 50,
        type: 'text',
        value: state.name,
      } as ValidationObjectModel)
    ) {
      newErrors.nameError = validateForm({
        type: 'text',
        maxLength: 50,
        value: state.name,
        section: 'Name of the ds division',
      } as ValidationObjectModel)
    }
    if (
      validateForm({
        maxLength: 50,
        type: 'text',
        value: state.code,
      } as ValidationObjectModel)
    ) {
      newErrors.codeError = validateForm({
        type: 'text',
        maxLength: 50,
        value: state.code,
        section: 'Code of the ds division',
      } as ValidationObjectModel)
    }

    return newErrors
  }

  const handleSubmit = () => {
    const foundErrros = findFormErrors()
    if (Object.keys(foundErrros).length > 0) {
      showTotast(
        ALERT_WARNING,
        validationError,
        TOAST_POSITION_TOP_RIGHT,
        5,
        TOAST_TRANSITION_SLIDE
      )
      setErrors(foundErrros)
    } else {
      setErrors(foundErrros)
      setShowConfirmation(true)
    }
  }
  const handleConfirm = async () => {
    const newState = produce(state, (draft) => {
      draft.districtId = distrit.id
      draft.provinceId = province.id
    })

    const result = await metaDataService.apiUpdateDsDivistion(
      match.params.dsId,
      newState
    )
    let success = false
    let message = result.errorMessage ? result.errorMessage : ''
    if (result.status === 200) {
      success = true
      message = 'Ds Division successfully updated'
      dispatch(dsFetchRequest())
      history.goBack()
    }
    showTotast(
      success ? ALERT_SUCCESS : ALERT_WARNING,
      message,
      TOAST_POSITION_TOP_RIGHT,
      5,
      TOAST_TRANSITION_SLIDE
    )
  }

  return (
    <>
      <Row className="title-layout">
        <Col className="d-flex justify-content-start">
          {/* <img
            src={
              '/src/assets/images/systemConfiguration/supporting-document.svg'
            }
            alt=""
          /> */}
          <span className="m-2">Manage Ds Division</span>
        </Col>
      </Row>
      <Row className="add-Incident-Type-page-layout">
        <Col sm={12} className="border-label">
          <div className="border-label-span">Modify Ds Division</div>
          <Form>
            <Form.Group className="mb-3" controlId="branchCode">
              <Form.Label>Province</Form.Label>
              <Form.Control disabled value={province.name} />
              <InvalidFeedback message={errors.codeError} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="branchCode">
              <Form.Label>District</Form.Label>
              <Form.Control disabled value={distrit.name} />
              <InvalidFeedback message={errors.codeError} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="branchCode">
              <Form.Label>
                Code <span className="required-field-astrix">*</span>
              </Form.Label>
              <Form.Control
                value={state.code}
                isInvalid={!!errors.codeError}
                type="text"
                onChange={(e) => {
                  const newVal = produce(state, (draft) => {
                    draft.code = e.target.value
                  })
                  setSate(newVal)
                  const clearError = produce(errors, (draft) => {
                    draft.codeError = ''
                  })
                  setErrors(clearError)
                }}
              />
              <InvalidFeedback message={errors.codeError} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="bankName">
              <Form.Label>
                Name <span className="required-field-astrix">*</span>
              </Form.Label>
              <Form.Control
                value={state.name}
                isInvalid={!!errors.nameError}
                type="text"
                onChange={(e) => {
                  const newVal = produce(state, (draft) => {
                    draft.name = e.target.value
                  })
                  setSate(newVal)
                  const clearError = produce(errors, (draft) => {
                    draft.nameError = ''
                  })
                  setErrors(clearError)
                }}
              />
              <InvalidFeedback message={errors.nameError} />
            </Form.Group>
          </Form>
          <Row>
            <Col sm={12} className="d-flex justify-content-end mt-4">
              <button
                className="cancel-button"
                onClick={(e) => {
                  e.preventDefault()
                  history.goBack()
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="save-button"
                onClick={handleSubmit}
              >
                Save
              </button>
            </Col>
          </Row>
        </Col>
        {showConfirmation && (
          <ConfirmationModal
            name={'Confirmation'}
            message={'Are you sure to modify this ds division ?'}
            onCancel={() => {
              setShowConfirmation(false)
            }}
            onConfirm={handleConfirm}
          />
        )}
      </Row>
    </>
  )
}

export default ModifyDsDivistion
